import m from "../../geodata/es2015/barbadosLow";
window.am4geodata_barbadosLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/barbadosLow.js
// module id = null
// module chunks = 